<div class="gt-routes-list-containerss">
  <dx-data-grid id="gridContainer" #emailReportConfigGrid [dataSource]="emailReportConfig"
    class="gt-data-grid-style export-grid" (onSaving)="onSaving($event)" [showRowLines]="true" [showBorders]="true"
    [editing]="{
      mode: 'form',
      texts: { saveRowChanges: confirmText, cancelRowChanges: cancelText }
    }" [allowColumnResizing]="true" [columnResizingMode]="'widget'" [columnAutoWidth]="false" [showBorders]="true"
    [scrolling]="{ mode: 'standard', useNative: true }" [width]="'100%'" class="gt-data-grid-style"
    [rowAlternationEnabled]="true" [hoverStateEnabled]="true">
    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-editing mode="form"></dxo-editing>
    <dxo-search-panel i18n-placeholder="@@search..." placeholder="Search..." [visible]="true" [highlightCaseSensitive]="false" class="gt-search-panel"
      width="17vw"></dxo-search-panel>
    <dxo-toolbar>
      <dxi-item width="50%" name="searchPanel" location="before"></dxi-item>
      <dxi-item width="50%">
        <div class="gt-flex-dir-row"></div>
      </dxi-item>
    </dxo-toolbar>

    <dxi-column dataField="role" i18n-caption="@@role" caption="Role" alignment="left" cellTemplate="roleCellTemplate"
      editCellTemplate="roleCellTemplate"></dxi-column>

    <div *dxTemplate="let item of 'roleCellTemplate'">
      {{ getRoleLabel(item.data.role) }}
    </div>

    <dxi-column dataField="users" i18n-caption="@@persons" caption="Persons" cellTemplate="cellTemplate"
      editCellTemplate="editCellTemplate">
      <div *dxTemplate="let item of 'cellTemplate'">
        <dx-tag-box [dataSource]="entraUsers" [contentEditable]="false" [readOnly]="true" [displayExpr]="getDisplayName"
          valueExpr="emailAddress" [showSelectionControls]="true" [(value)]="item.data.users"
          (onValueChanged)="onTagValueChanged($event, item.data.role)" [elementAttr]="{ class: 'readonly-tagbox' }"
          placeholder="">
        </dx-tag-box>
      </div>

      <div *dxTemplate="let item of 'editCellTemplate'">
        <dx-tag-box [dataSource]="entraUsers" [contentEditable]="false" [displayExpr]="getDisplayName"
          valueExpr="emailAddress" [showSelectionControls]="true" [showDropDownButton]="true" [(value)]="editingUsers"
          itemTemplate="customDropDownItem">
          <div *dxTemplate="let item of 'customDropDownItem'">
            <span>{{ item.firstName }} {{ item.lastName }} |
              {{ item.emailAddress }}</span>
          </div>
        </dx-tag-box>
      </div>
    </dxi-column>

    <dxi-column dataField="" allowEditing="false" cellTemplate="buttonCellTemplate" [width]="34"
      [formItem]="{ visible: false }">
      <div *dxTemplate="let item of 'buttonCellTemplate'">
        <div class="gpd-table-actions">
            <app-svg-icon icon="edit" color="var(--color-primary)" [size]="20" [strokeWidth]="1.5" i18n-title="@@edit" title="Edit" (click)="editRow(item.data.role)"></app-svg-icon>
          </div>
      </div>
    </dxi-column>
  </dx-data-grid>
</div>

<dx-toast [(visible)]="toastVisible" i18n-message="@@successfullySaved" message="Successfully saved"></dx-toast>